// "First steps" checklist for brand-new accounts (FirstStepsCard in the home feed).
export const onboarding: Record<string, string> = {
  'First steps': 'Prvi koraci',
  'Dismiss': 'Sakrij',
  'done': 'gotovo',
  'No real money, no subscription — everything here is a simulated $10,000 account.':
    'Bez pravog novca, bez pretplate — sve ovde radi na simuliranom nalogu od $10.000.',
  'Follow 3 traders': 'Zaprati 3 trejdera',
  'Their signals land in your Following tab and notifications.': 'Njihovi signali stižu u tvoj tab Pratim i u notifikacije.',
  'Follow': 'Zaprati',
  'Following': 'Pratiš',
  'closed trades': 'zatvorenih trejdova',
  'See all traders': 'Vidi sve trejdere',
  'Add an instrument to your watchlist': 'Dodaj instrument u listu praćenja',
  'Gold, EURUSD, BTC — pick what you already look at every day.': 'Zlato, EURUSD, BTC — izaberi ono što ionako gledaš svaki dan.',
  'Open watchlist': 'Otvori listu praćenja',
  'Post your first signal': 'Objavi prvi signal',
  'Entry, stop and target — the market settles it, not you. A wrong call costs nothing.':
    'Ulaz, stop i cilj — presuđuje tržište, ne ti. Pogrešna procena ne košta ništa.',
  'Post a signal': 'Objavi signal',
  'Learn how the score works': 'Pogledaj kako radi skor',
  '2 minutes: what counts, what does not, how you get on the leaderboard.': '2 minuta: šta se računa, šta ne, kako se ulazi na rang listu.',
  'Show me': 'Pokaži mi',
  'All done — the leaderboard is waiting.': 'Sve urađeno — rang lista čeka.',
};
